import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";

const REGIONS = ["All", "North", "West", "Central", "East", "South"];

export default function AfricaMap({ delegations = [] }) {
  const [region, setRegion] = useState("All");
  const navigate = useNavigate();

  const filtered = useMemo(
    () => delegations.filter((d) => region === "All" || d.region === region),
    [delegations, region]
  );

  return (
    <div data-testid="africa-map">
      <div className="mb-6 flex flex-wrap gap-2">
        {REGIONS.map((r) => (
          <button
            key={r}
            data-testid={`map-region-${r.toLowerCase()}`}
            onClick={() => setRegion(r)}
            className={`rounded-full px-4 py-1.5 text-xs font-display uppercase tracking-wider transition-all ${
              region === r ? "gold-bg text-obsidian" : "border border-gold/25 text-gold/70 hover:border-gold/60"
            }`}
          >
            {r === "All" ? "All Africa" : r}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5">
        {filtered.map((d) => (
          <button
            key={d.code}
            data-testid={`map-delegation-${d.code}`}
            onClick={() => navigate(`/delegations/${d.code}`)}
            className="card-lux flex items-center gap-2.5 p-3 text-left hover:bg-obsidian-600"
          >
            <span className="text-2xl leading-none">{d.flag}</span>
            <span className="min-w-0">
              <span className="block truncate text-sm text-amber-50">{d.name}</span>
              <span className="block text-[0.65rem] uppercase tracking-wider text-muted-foreground">{d.region}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
